import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CSS from 'csstype';
import { EFonts } from 'libs/styles/styling';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

export interface IProps {
    style?: CSS.Properties;
    className?: string;
}

export const MapBlockedPage = (): JSX.Element => {
    return (
        <S_MapBlockedPage>
            <S_Error>
                <S_Left>
                    <S_Icon icon={['far', 'lock']} />
                </S_Left>
                <S_Right>
                    <S_Title>{Localization.MAP_NOT_ACCESSIBLE}</S_Title>
                    <S_Text>{Localization.MAP_NOT_ACCESSIBLE_DESC}</S_Text>
                </S_Right>
            </S_Error>
        </S_MapBlockedPage>
    );
};

const S_MapBlockedPage = styled.div`
    width: 100%;
    height: 100%;
    background-color: #e1e1e1;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const S_Error = styled.div`
    display: flex;
    background: linear-gradient(180deg, #323b7c 0%, #1d255e 100%);
    box-shadow: 10px 10px 50px rgba(0, 0, 0, 0.25);
    border-radius: 20px;
    padding: 70px 55px 80px 55px;
`;

const S_Left = styled.div`
    margin: 0 40px 0 0;
`;

const S_Icon = styled(FontAwesomeIcon)`
    color: white;
    font-size: 65px;
    margin: 5px 0 0 0;
`;

const S_Right = styled.div`
    display: flex;
    flex-direction: column;
`;

const S_Title = styled.div`
    font-size: 25px;
    line-height: 31px;
    color: #ffffff;
    margin: 0 0 20px 0;
    font-weight: ${EFonts.Bold};
`;

const S_Text = styled.div`
    font-size: 16px;
    line-height: 20px;
    color: #ffffff;
`;
